import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { identityApiRef, useApi } from '@mainstage/core-plugin-api';
import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { teamRolesApiRef } from '../plugin';
import { useTeamRolesPanelContext } from '../context';
import { TeamRoleEnum } from '@agilelab/plugin-wb-team-roles-common';
import { usePublishEvent } from '@agilelab/plugin-wb-events';
import { stringifyEntityRef } from '@mainstage/catalog-model';
import { teamRolesOnboardedTopic } from '@agilelab/plugin-wb-events-common';

export const useOnboardProject = () => {
  const alertApi = useApi(customAlertApiRef);
  const teamRolesApi = useApi(teamRolesApiRef);
  const identityApi = useApi(identityApiRef);
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);

  const { projectUrn, refresh, project } = useTeamRolesPanelContext();
  const { publish } = usePublishEvent({
    generatorSystem: 'builder',
    keyBuilderCatalog: stringifyEntityRef(project),
  });

  const handleOnboardProject = useCallback(async () => {
    try {
      setLoading(true);

      const identity = await identityApi.getBackstageIdentity();
      const options = await identityApi.getCredentials();

      await teamRolesApi.addAssignee({
        projectUrn,
        teamRole: TeamRoleEnum.OWNER,
        subject: identity.userEntityRef,
        options,
      });

      publish(teamRolesOnboardedTopic, {
        subject: identity.userEntityRef,
        entityUrn: projectUrn,
        isManuallyOnboarded: true,
      });

      alertApi.post({
        message: 'Project onboarded successfully',
        severity: 'success',
      });
    } catch (error) {
      alertApi.post({
        message: `Failed to onboard project. Please try again or contact the Platform Team. ${
          error instanceof Error ? error.message : 'Unknown error'
        }`,
        severity: 'error',
      });
    } finally {
      setLoading(false);
      refresh();
      queryClient.invalidateQueries();
    }
  }, [
    alertApi,
    refresh,
    teamRolesApi,
    identityApi,
    queryClient,
    projectUrn,
    publish,
  ]);

  return { loading, handleOnboardProject };
};
